import { ReactNode } from "react";

import RadioButton from "@/components/ui/radio";
import { EOutputGridType, OutputGridType } from "@/types/spatial";

type Props = {
  selected?: OutputGridType | null;
  onChange: (value: OutputGridType) => void;
};

type RadioGroupProps = {
  /** Unique name for each radio button */
  name: string;
  value: boolean;
  onChange: () => void;
  title: string;
  description: ReactNode;
};

const RadioGroup = ({
  name,
  title,
  description,
  value,
  onChange
}: RadioGroupProps) => {
  return (
    <label className="flex items-start cursor-pointer">
      <RadioButton name={name} checked={value} onCheck={onChange} />{" "}
      <div className="ml-2 flex flex-col">
        <div className="flex flex-col">
          <span className="text-txtPlaceholder font-bold">{title}</span>
          <p className="text-[10px]">{description}</p>
        </div>
      </div>
    </label>
  );
};

const GridOutput = ({ selected, onChange }: Props) => {
  const gridOptions = [
    {
      value: EOutputGridType.GEOHASH,
      label: "Geohash",
      description: (
        <>
          Geohash is a compact identifier for Earth's regions, converting
          latitude and longitude into a short alphanumeric string, ideal for{" "}
          <span className="font-bold">Grid Analysis</span>.
        </>
      )
    },
    {
      value: EOutputGridType.H3,
      label: "H3",
      description: (
        <>
          H3 (Hexagonal Hierarchical Spatial Index) is a geospatial system that
          divides Earth into hexagonal cells, each with a unique index.
        </>
      )
    }
  ];

  return (
    <div>
      {gridOptions.map((option) => (
        <RadioGroup
          key={option.value} // Add keys for React list rendering
          name={`grid-output-${option.value}`}
          title={option.label}
          description={option.description} // Now a JSX element
          value={selected === option.value}
          onChange={() => onChange(option.value)} // Pass the onChange function directly
        />
      ))}
    </div>
  );
};

export default GridOutput;
